export default __webpack_public_path__ + "static/media/slide1.53d16d8d.png";